import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import CommonHeader from "../../../Components/Common/CommonHeader/CommonHeader";
import TableWrapper from "../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import {
  btnAccessChecker,
  checkButtonAccess,
  getOrgId,
} from "../../../Utils/CommonUtils";
import {
  getFilteredDataWithTabs,
  getListing,
  getListingByOrgId,
} from "../../../Utils/CommonService";
import { setProductData } from "../../../slices/product/productSlice";
import useOemColumns from "./Hooks/useOemColumns";
import AffinityGroupFilter from "../../AG/AffinityGroup/AffinityGroupFilter";
import AddNewOem from "./Modal/AddNewOem";
import { resetFormState } from "../../../slices/common/reducer";
import {
  setOemData,
  setOemFilterForm,
  setOemSorting,
} from "../../../slices/oem/oemSlice";
import OemFilter from "./OemFilter";

const OemListing = () => {
  const dispatch = useDispatch();
  const { oemColumns } = useOemColumns();
  const modalShow = useSelector((state) => state.common.modalShow);
  const editShow = useSelector((state) => state.common.editShow);
  const oemData = useSelector((state) => state.oem.oemData);
  const triggerRender = useSelector((state) => state.common.triggerRender);
  const apiTabData = useSelector((state) => state.common.pagination.tabs);
  const selector = useSelector((state) => state.moduleaccesstree);
  const filterApi = useSelector((state) => state.oem.filter.filterApi);
  const filterForm = useSelector((state) => state.oem.filter.form);
  const sortColumn = useSelector((state) => state.oem.sorting.column);
  const sortOrder = useSelector((state) => state.oem.sorting.order);
  const totalRows = useSelector((state) => state.common.pagination.totalCount);
  // const organizationId = getOrgId();
  const enterpriseid = localStorage.getItem("enterpriseid");
  const selectedUser = useSelector((state) => state.header.selectedUser);

  // const selectedUser = localStorage.getItem("selectedUser");
  // const organizationId = selectedUser ? JSON.parse(selectedUser).name : null;

  // const [organizationId, setOrganizationId] = useState(null);

  // // useEffect to retrieve organization ID from localStorage
  // useEffect(() => {
  //   const selectedUser = localStorage.getItem("selectedUser");
  //   if (selectedUser) {
  //     const parsedUser = JSON.parse(selectedUser);
  //     const orgId = parsedUser.organizationid;
  //     setOrganizationId(orgId);
  //   }
  // }, []);

  useEffect(() => {
    dispatch(setOemFilterForm({ type: "reset" }));
  }, []);

  return (
    <div>
      <CommonHeader
        newButton={true}
        buttonTitle={"New OEM"}
        checkAccessCreate={checkButtonAccess("CREATE", "PROD_OEM")}
        filterComponent={<OemFilter />}
        dash={true}
      />
      <div>
        <TableWrapper
          columns={oemColumns}
          data={oemData}
          apiTabData={apiTabData}
          paginatedApi
          filterApi={filterApi}
          filterApiEntity={"OEM"}
          filterApiListEntity={"OEM"}
          filterApiFunction={setOemData}
          filterApiService={getFilteredDataWithTabs}
          filterForm={filterForm}
          totalRows={totalRows}
          status={"ALL"}
          statusColumn={"status"}
          hideTabsWrapper={true}
          serverSort
          serverSortColumn={sortColumn}
          serverSortOrder={sortOrder}
          serverSortState={setOemSorting}
          organizationId={selectedUser.organizationid}
          enterpriseId={enterpriseid}
        />
      </div>
      {(modalShow || editShow) && <AddNewOem />}
    </div>
  );
};

export default OemListing;
